export default "__VITE_ASSET__y0UMtQxU__"